export default "__VITE_ASSET__DHdc5_ZY__"